import * as React from "react";
import HasOwnership from "components/common/HasOwnership";
import IconButton from "components/common/IconButton";
const ShareButton = ({
  entityId,
  entityType,
  onClick,
  disabledInfo = void 0,
  bsSize = void 0,
  bsStyle = "default",
  title = "Share",
  showTitle = false
}) => /* @__PURE__ */ React.createElement(HasOwnership, { id: entityId, type: entityType }, ({ disabled: hasMissingPermissions }) => {
  const isDisabled = !!disabledInfo || hasMissingPermissions;
  const tooltipLabel = isDisabled ? disabledInfo || `Only owners of this ${entityType.replaceAll("_", " ")} can share it.` : title;
  return /* @__PURE__ */ React.createElement(
    IconButton,
    {
      name: "person_add",
      title: tooltipLabel,
      ariaLabel: title,
      bsStyle,
      iconSize: "inherit",
      size: bsSize,
      onClick,
      disabled: isDisabled,
      showTitle,
      allowClickWhenDisabled: true
    }
  );
});
export default ShareButton;
